import type { PullRequestDetail } from "@afar-research/contracts";
import {
  usePullRequestSurfaceStore,
  type PullRequestSurfaceDescriptor,
} from "../pullRequestSurfaceStore";
import { useEnvironments } from "../state/environments";
import { executePullRequestDiscussion } from "../pullRequestDiscussionCommand";
import { PullRequestLifecycleForm } from "./PullRequestLifecycleForm";

export function PullRequestLifecycle({
  descriptor,
  detail,
  active,
}: {
  readonly descriptor: PullRequestSurfaceDescriptor;
  readonly detail: PullRequestDetail;
  readonly active: boolean;
}) {
  const session = usePullRequestSurfaceStore((state) => state.lifecycles.get(descriptor.id));
  const { environments } = useEnvironments();
  const environment = environments.find((item) => item.environmentId === descriptor.environmentId);
  if (
    !session ||
    environment?.serverConfig?.environment.capabilities.pullRequestLifecycle !== "lifecycle-v1"
  )
    return null;
  return (
    <PullRequestLifecycleForm
      descriptor={descriptor}
      detail={detail}
      session={session}
      mergeEnabled={
        environment.serverConfig?.environment.capabilities.pullRequestMerge === "merge-v1"
      }
      enabled={active && environment.connection.phase === "ready"}
      execute={executePullRequestDiscussion}
    />
  );
}
